import React from "react";
import Context from "../../../context/Context";
import DateTime from "./DateTime";
import Duration from "./Duration";
import * as component from "../../util/component";
import * as dateUtil from "../Events/dateUtil";

export default class When extends React.Component {

  componentId;
  durationComponent;
  startComponent;
  endComponent;

  constructor(props) {
    super(props);
    this.componentId = component.nextId("when-");
    this.state = component.newState({});
  }

  componentDidMount() {
    if (this.props.onMount) this.props.onMount(this);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  render() {
    const i18n = Context.instance.i18n;
    const when = Object.assign({},this.props.criteria.when);
    const onPartChanged = (c,type,dateMoment,timeMoment,prev) => {
      let c2 = this.endComponent;
      if (c === this.endComponent) c2 = this.startComponent;
      c2.whenAssociatedPartChanged(c,type,dateMoment,timeMoment,this.durationComponent,prev);
    };
    return (
      <div className="i-filter-form">
        <div>
          <Duration
            formKey={this.componentId}
            duration={when.duration}
            criteria={when}
            onMount={c => this.durationComponent = c}/>
        </div>
        <div>
          <DateTime
            formKey={this.componentId}
            duration={when.duration}
            criteria={when}
            label={i18n.meetingRooms.start}
            isStart={true}
            date={when.start.date}
            onMount={c => this.startComponent = c}
            onPartChanged={onPartChanged} />
        </div>
        <div>
          <DateTime
            formKey={this.componentId}
            duration={when.duration}
            criteria={when}
            label={i18n.meetingRooms.end}
            isEnd={true}
            date={when.end.date}
            startDate={when.start.date}
            onMount={c => this.endComponent = c}
            onPartChanged={onPartChanged} />
        </div>
      </div>
    );
  }

  validate(criteria) {
    let ok = true;
    let when = {
      duration: null,
      start: {},
      end: {}
    };
    if (ok) ok = this.durationComponent.validate(when);
    if (ok) ok = this.startComponent.validate(when.start);
    if (ok) ok = this.endComponent.validate(when.end);
    if (ok) {
      if (when.start.date && when.end.date &&
         (when.start.date <= when.end.date)) {
        // also check isRequired?
      }
    }
    if (ok && when.start.date && when.end.date &&
        when.duration !== "allDay") {
      let dt1 = new Date(when.start.date);
      let dt2 = new Date(when.end.date);
      let d = dateUtil.getDurationKey(dt1,dt2);
      when.duration = d;
    }
    if (ok) {
      criteria.when = when;
    }
    return ok;
  }

}
